import React, { forwardRef, useMemo } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';

const getDisplayName = (appliedFilters) => {
  if (appliedFilters.length > 1) {
    return (
      <FormattedMessage
        defaultMessage='(Multiple Rate Shoppers)'
        description='orders.filterOptions.multipleServiceCollections'
        id='pdPi/W'
      />
    );
  }

  return <FormattedMessage defaultMessage='Rate Shopper' description='orders.filterOptions.serviceCollection' id='3YU5gJ' />;
};

export const RateShopper = forwardRef((props, ref) => {
  const appliedFilters = useSelector((state) =>
    Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
      filterById: props.filterById,
    }),
  );

  const displayContent = useMemo(() => getDisplayName(appliedFilters), [appliedFilters]);
  return <ActionableFilterPill {...props} ref={ref} displayContent={displayContent} isSelected={!!appliedFilters.length} />;
});

RateShopper.propTypes = {
  filterById: PropTypes.string,
};
